import { useMutation } from '@tanstack/react-query';
import { updateCarePlan } from '../services/care_plan';

const UpdateCarePlan = () => {
    const updateCarePlanMutation = useMutation({
        mutationFn: ({ carePlanId, carePlan }) => updateCarePlan(carePlanId, carePlan),
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Error updating care plan:', error);
        },
    });

    return updateCarePlanMutation;
};

export default UpdateCarePlan; 